import { Loader } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

export let shouldOpen = false;

export default Loader(({ node }, load) => {
  const { loadTarget } = node.dataset;

  if (!loadTarget) {
    return;
  }

  const targets = loadTarget.split(',');

  const handler = (event: Event) => {
    const target = event.target as HTMLElement;
    const trigger = target.closest<HTMLElement>('[data-load]');

    if (!trigger) {
      return;
    }

    const loadValues = NonNullish(
      trigger.dataset.load,
      'Trigger must have a "data-load" attribute',
    ).split(',');
    const matches = targets.some((value) => loadValues.includes(value));

    if (!matches) {
      return;
    }

    event.stopPropagation();

    document.removeEventListener('click', handler, true);
    shouldOpen = true;
    load();
  };

  document.addEventListener('click', handler, true);
});
